$(document).ready(function () {
    let isMobile = false;
    let vPort = 'screen-xs';
    let homeSearchInput = document.querySelector('.homepage-search-container #searchField1');
    let homeSearchInputPlaceholder = '';

    const searchFieldPlaceholderSetter = () => {
        homeSearchInputPlaceholder = isMobile ? 'Search' : 'Search publications, articles, keywords, etc.';
        homeSearchInput?.setAttribute('placeholder', homeSearchInputPlaceholder);
    };
    document.addEventListener(`${vPort}-on`, () => {
        isMobile = true;
        searchFieldPlaceholderSetter();
    });

    document.addEventListener(`${vPort}-off`, () => {
        isMobile = false;
        searchFieldPlaceholderSetter();
    });

    $('.hp-browse-by-controller').click(function (e) {
        if (window.innerWidth < 769) {
            e.preventDefault();
            $(this).find('.icon').toggleClass(' icon-chevron-down icon-chevron-up');
            $(this).siblings('.hp-browse-by-content').toggle();
        }
    });
    $('.icon-login-mobile img').click(function (e) {
        e.preventDefault();
        $(this).parent('.icon-login-mobile').siblings('.login-register-container').toggle();
    });

    // check if the user non-institution
    if ($('.institution-info-wrapper').is(':empty')) {
        $('.UX3InstitutionBanner').addClass('non-institution');
    }
});
